const actionTypes = {
  FetchedCreditCards: 'CREDIT_CARDS_FETCHED',
  FetchedCreditCardsAdyen: 'CREDIT_CARDS_ADYEN_FETCHED',
};

export default actionTypes;
